// extracted by mini-css-extract-plugin
export default {"bucketContainer":"Bucket_bucketContainer__ygWdW","bucketCard":"Bucket_bucketCard__b1QwO","cardBtns":"Bucket_cardBtns__IZ7bp","editButton":"Bucket_editButton__kfZjf"};